import {handleActions} from 'redux-actions';
import {FamilyMember} from '../constants/models';

const  FamilyMemberReducers = handleActions({
    SET_INDEX_FAMILY_MEMBER: (state, {payload}) => (
        state.merge({
            index_data: payload
        })
    ),
    SET_NEW_FAMILY_MEMBER: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, FamilyMember);

export default FamilyMemberReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/FamilyMemberReducers.jsx